import axios from 'axios';

/**
 * @description: 埋点ajax
 * @param {Number} origin => 8-学习日记
 * @param {Number} action => 1-访问首页，27-点击打卡，6-点击分享海报，28-点击稿件列表,29-访问详情页
 * @param {String} articleID: 文章id
 * @param {String} optionId:tabId
 * @param {String} optionName:tabName
 */

const { NODE_ENV } = process.env
const urlArr = {
  production: 'https://caiji.nfapp.southcn.com/analytics/sendRecord',
  test: 'https://testcaiji.nfapp.southcn.com/analytics/sendRecord',
  development: 'https://testcaiji.nfapp.southcn.com/analytics/sendRecord'
}
const BASE_URL = urlArr[NODE_ENV] || 'https://testcaiji.nfapp.southcn.com/analytics/sendRecord'

const savePoint = (params) => {
  axios.get(BASE_URL, {
    params
  }).then((res) => res.data.data).catch(err => {

  })
}
export {
  savePoint,
  BASE_URL
}